import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	initOrphanProjectsList,
	fetchOrphanProjectsSuccess,
} from './orphan-project.actions';
import { OrphanProjectState } from './orphan-project.state';

export const orphanProjectReducer = createReducer<OrphanProjectState>(
	new OrphanProjectState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initOrphanProjectsList, (state) => state.setLoading(true)),
	on(fetchOrphanProjectsSuccess, (state, action) =>
		state
			.setOrphanProjectList(action.orphanProjectList)
			.setAdmins(action.admins)
			.setLoading(false)
	)
);
